'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisclosureTriangle = function DisclosureTriangle(_ref) {
  var onClick = _ref.onClick,
      expanded = _ref.expanded;

  var disclosureTriangle = void 0;
  if (expanded) {
    disclosureTriangle = '▼';
  } else {
    disclosureTriangle = '►';
  }

  return _react2.default.createElement(
    'span',
    {
      onClick: onClick,
      style: { cursor: 'pointer' },
      role: 'button',
      'aria-pressed': expanded,
      tabIndex: '0'
    },
    disclosureTriangle
  );
};

DisclosureTriangle.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool
};

DisclosureTriangle.defaultProps = {
  expanded: null
};

exports.default = DisclosureTriangle;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/DisclosureTriangle.js
// module id = 407
// module chunks = 0